<template>
  <v-card v-if="entity.relatedFiles">
    <v-card-text>
      <h2><v-icon>folder</v-icon>File list</h2>
      <div v-for="file in entity.relatedFiles" :key="file.id">
        <FileZ :file="file" />
        <span>&#160;</span>
        <strong>
          <span v-if="file.category">{{ file.category.shortname }}</span>
          <span v-if="!file.category">{{ file.categoryid }}</span>
        </strong>
        <span>&#160;</span>
        <span v-if="file.subjectProperty">{{ file.subjectProperty }}</span>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import FileZ from "@/components/link/FileZ";
export default {
  name: "RelatedFiles",
  components: {
    FileZ
  },
  props: ["entity"]
};
</script>
